module.exports = __webpack_public_path__ + "static/b-acomodacoes-4642951d20ddebf9704cf44ec1017f47.jpg";